<template>
    <div id="nilai-reagen-create">
      <div class="vx-row">
        <div class="vx-col w-1/2 mt-2">
          <vx-card class="mb-base" title="Form Setting Harga">
            <div class="vx-row">
              <div class="vx-col w-full mt-2 mb-2">
                <vs-select
                  :disabled="disable"
                  class="w-full"
                  name="type"
                  label="Type"
                  v-model="typex"
                  v-on:change="typeChg"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item,index) in [{id : 1, name : 'Paket Pemeriksaan'}, {id : 2, name : 'Pemeriksaan'},{id : 3, name : 'Service Lainnya'}]"
                  />
                </vs-select>
              </div>
              <!--div class="vx-col w-full mt-2 mb-2">
                <vs-select
                  autocomplete
                  :disabled="disable"
                  class="w-full"
                  name="panel"
                  label="Paket Pemeriksaan"
                  v-model="panel"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item,index) in listPanel"
                  />
                </vs-select>
              </div-->
              <div class="vx-col w-full mt-2 mb-2" v-if="typex==2">
                <vs-select
                  autocomplete
                  :disabled="disable"
                  class="w-full"
                  name="measure"
                  label="Pemeriksaan"
                  v-model="measure"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item,index) in listMeasure"
                  />
                </vs-select>
              </div>
              <div class="vx-col w-full mt-2 mb-2" v-if="typex==3">
                <vs-input class="w-full" v-model="servicex" label="Layanan Lainnya" />
              </div>
              <div class="vx-col w-full mt-2 mb-2">
                <vs-input class="w-full" v-model="price" type="number" label="Harga" @blur="isInputActive = false"
                  @focus="isInputActive = true"
        					@keyup="num($event)"/>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.go(-1)"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>
    </div>
</template>

<script>
import lab from "@/api/lab";
import master from "@/api/master";

export default {
  data() {
    return {
      id: null,
      disable : false,
      typex: null,
      panel : null,
      measure : null,
      servicex : null,
      price: '',
      listPanel: [],
      listMeasure: [],
      isInputActive: false
    };
  },
  methods: {
    typeChg() {
      if (!this.id) {
        this.panel = null, this.measure = null, this.price = '';
      }

      if (this.typex == 1) {
        this.$vs.notify({
          title: "Info",
          time: 3000,
          text:
            "Fitur belum tersedia",
          color: "success",
          position: "top-right"
        });
      } else if (this.typex == 2) {
        this.getPCRMeasure();
      }
    },
		listen(newVal, schema) {
		},
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

      let model = {};
      model.type = this.typex;
      if (this.panel) {
        model.panel = {id: this.panel};
      }
      if (this.measure) {
        model.measure = {id: this.measure};
      }

      if (this.servicex) {
        model.otherService = this.servicex;
      }
      model.price = this.price;
      if (this.id) {
        model.id = this.id;
      }

			lab.savePriceSetting(model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/pemeriksaan/harga/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});

		},
		async firstLoad() {
      let idx = this.$route.params.id;
      if (idx) {
        const xmodel = await lab.getPriceSetting(idx);

        if (xmodel.data.data[0]) {
          this.typex = xmodel.data.data[0].type;
          if (xmodel.data.data[0].measure) {
            this.measure = xmodel.data.data[0].measure.id;
          }
          if (xmodel.data.data[0].panel) {
            this.panel = xmodel.data.data[0].panel.id;
          }
          if (xmodel.data.data[0].otherservice) {
            this.servicex = xmodel.data.data[0].otherservice;
          }
          this.price = xmodel.data.data[0].price;
        }
        this.id = idx;
      }
    },
    async getPCRMeasure() {
			//const panels = await test.getAvailableTestPCR({perPage:100000});
      const pcrMeasure = JSON.parse(localStorage.getItem("listAvailableTestPCR"));
      let pcrMeasureArr = []
      pcrMeasure.map(function(item) {
        let arr = {};
        arr.id = item.id;
        arr.name = item.parameterName;

        pcrMeasureArr.push(arr);
      });

      this.listMeasure = pcrMeasureArr;
		},
		num: function(event) {
			const allowed = [
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"-",
				".",
				","
			];
			const keyPressed = event.key;
			if (allowed.includes(keyPressed) == false) {
				event.preventDefault();
			}
/*
      if (this.price == null) {
          return "";
      }
      let newVal = this.price || 0;

      if(parseFloat(newVal) % 1 === 0) {
          this.price = parseFloat(newVal).toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
      } else {
          this.price = newVal.toString().replace(/\./g, ',');
      }*/
		}
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>
